import { Component, Inject, OnDestroy, AfterViewInit, ChangeDetectorRef, AfterContentInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IQrData } from '@app/core/info/qr/qr';
import { InfoService } from '@app/core/info/info.service';
import { AppConfig } from '@app/config/app.config';

@Component({
  selector: 'cloud-qr',
  templateUrl: './qr.component.html',
  styleUrls: ['./qr.component.scss']
})
export class QrComponent implements OnDestroy, AfterContentInit {
  qrString: string;
  timeLeft: number;
  timer: NodeJS.Timer;
  wait = true;
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<QrComponent>,
    public info: InfoService,
    @Inject(MAT_DIALOG_DATA) public data: IQrData
  ) {
  }

  ngAfterContentInit(): void {
    this.info.endWait();
    this.data.getQrAction.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((res: string | false) => this.setQrAndWatch(res));
  }

  private setQrAndWatch(qr: string | false) {
    this.startTimer();
    if (qr) {
      this.qrString = qr;
      this.wait = false;

      this.data.confirmAction.pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe(res => {
        this.close(res);
      });
    } else {
      // TODO
      // this.info.error('TODO');
      this.close();
    }
  }

  private startTimer() {
    this.timeLeft = AppConfig.loginTime;
    this.timer = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft < 1) {
        clearInterval(this.timer);
        this.close();
      }
    }, 1000);
  }

  close(res: boolean = false): void {
    this.wait = false;
    this.dialogRef.close(res);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
